import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import colors from '../../theme/colors';

// series: { fieldName: [[ts, val], ...], ... }
// config: { title, yAxisLabel, yAxisUnit, height, seriesConfig: { fieldName: { name, color, yAxis } } }
export default function TimeSeriesChart({ series, config = {} }) {
  const options = useMemo(() => {
    if (!series || Object.keys(series).length === 0) {
      return null;
    }

    const seriesConfig = config.seriesConfig || {};
    const yAxes = config.yAxes || [{ title: { text: config.yAxisLabel || '' } }];

    const chartSeries = Object.entries(series).map(([field, data], i) => {
      const sc = seriesConfig[field] || {};
      return {
        name: sc.name || field,
        data,
        color: sc.color || colors.series[i % colors.series.length],
        yAxis: sc.yAxis || 0,
        type: sc.type || 'spline',
        tooltip: {
          valueSuffix: sc.unit ? ` ${sc.unit}` : '',
          valueDecimals: sc.decimals != null ? sc.decimals : 1,
        },
      };
    });

    return {
      chart: {
        height: config.height || 300,
        zoomType: 'x',
        panning: { enabled: true, type: 'x' },
        panKey: 'shift',
      },
      title: { text: config.title || '' },
      xAxis: {
        type: 'datetime',
        crosshair: true,
      },
      yAxis: yAxes.map((ya, i) => ({
        title: { text: ya.title?.text || '' },
        opposite: i > 0,
        gridLineColor: colors.cardBorder,
        labels: { style: { color: colors.textMuted } },
      })),
      series: chartSeries,
      tooltip: {
        shared: true,
        xDateFormat: '%H:%M:%S',
      },
      exporting: { enabled: true },
    };
  }, [series, config]);

  if (!options) {
    return (
      <div style={{ padding: 20, color: colors.textMuted, fontSize: 13, textAlign: 'center' }}>
        No chart data
      </div>
    );
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
